import { render, staticRenderFns } from "./SliderVideoLuminosity.vue?vue&type=template&id=872201de&scoped=true&"
import script from "./SliderVideoLuminosity.vue?vue&type=script&lang=js&"
export * from "./SliderVideoLuminosity.vue?vue&type=script&lang=js&"
import style0 from "./SliderVideoLuminosity.vue?vue&type=style&index=0&id=872201de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872201de",
  null
  
)

export default component.exports